import type { VariantProps } from 'class-variance-authority'
import type { AppConfig } from 'nuxt/schema'
import { cva } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'
export { default as AlertDescription } from './AlertDescription.vue'
export { default as AlertTitle } from './AlertTitle.vue'

export function alertVariants(appConfig: AppConfig) {
  return cva(appConfig.ui.alert.slots.root, {
    variants: appConfig.ui.alert.variants,
    defaultVariants: { ...appConfig.ui.alert.defaultVariants },
  })
}

export type AlertVariants = VariantProps<ReturnType<typeof alertVariants>>
